import { httpClient } from '@/app/libs';

interface GetPanelResponse {
  codigoPainel: string;
  statusPainel: number;
  idRoteiro: string | null;
  idPrograma: string | null;
  accessToken: string | null;
  refreshToken: string | null;
  nomeGrupoPainel: string | null;
  codigoDispositivo: string | null;
}

export async function getPanel(panelCode: string) {
  const { objeto } = await httpClient.get<{ objeto: GetPanelResponse }>(`/paineis/${panelCode}`, {
    safeErrorStatus: [401],
  });

  return {
    scriptId: objeto.idRoteiro,
    programId: objeto.idPrograma,
    panelCode: objeto.codigoPainel,
    accessToken: objeto.accessToken,
    panelStatus: objeto.statusPainel,
    refreshToken: objeto.refreshToken,
  };
}
